import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 830.953 75.893"
    // width={1661.907}
    // height={151.786}
    {...props}
  >
    <defs>
      <style>
        {
          '@font-face{font-family:"Virgil";src:url(https://excalidraw.com/Virgil.woff2)}@font-face{font-family:"Cascadia";src:url(https://excalidraw.com/Cascadia.woff2)}'
        }
      </style>
    </defs>
    <path
      d="M9.09 13.285c192.79-3.47 387.67-3.44 811.51-1.91m-811.06.59c320.52-2.47 639.01-1.26 810.82.34m-3.25-.42c2.05 18.45 6.94 38.47 4.18 54.45m-2.22-55.79c-.08 21.84 2.79 39.92 3.82 54.95m-2.16-1.29c-240.45 3.3-483.61 4.88-811.84.33m811.84-.87c-289.85-6.65-580.43-6.22-810.02.2m-.49 1.87c.74-20.63 3.96-43.51 2.31-50.44m-.78 49.14c-1.92-18.07-2.08-34.02-2.28-54.02"
      stroke="#000"
      fill="none"
      strokeLinecap="round"
    />
    <text
      y={22}
      fontFamily="Virgil, Segoe UI Emoji"
      fontSize={24.767}
      style={{
        whiteSpace: "pre",
      }}
      transform="translate(24.24 22.736)"
    >
      {"Hist\xF3ria"}
    </text>
    <path
      d="M148.039 10.1c-.56 9.3-4.67 46.94-5.59 55.79m3.53-50.49c.28 8.68 1.31 38.17 1.68 46.6"
      stroke="#000"
      fill="none"
      strokeLinecap="round"
    />
    <text
      y={22}
      fontFamily="Virgil, Segoe UI Emoji"
      fontSize={24.767}
      style={{
        whiteSpace: "pre",
      }}
      transform="translate(173.18 22.56)"
    >
      {"Pr\xEDbehy"}
    </text>
    <path
      d="M303.79 15.95c-.63 8.26.6 37.68 1 45.86m3-47.21c.02 8.82 2.89 42.78 2.24 50.5M436.118 12.812c.4 8.18 1.44 43.47 2.29 51.79m1.75-54.6c.15 7.28-4.47 41.64-4.41 51.01"
      stroke="#000"
      fill="none"
      strokeLinecap="round"
    />
    <text
      y={22}
      fontFamily="Virgil, Segoe UI Emoji"
      fontSize={24.767}
      style={{
        whiteSpace: "pre",
      }}
      transform="translate(474.297 22.034)"
    >
      {"FAQ"}
    </text>
    <path
      d="M579.019 13.872c-.4 7.22-2.61 40.09-2.5 48.46m-.26-43.75c.37 8.66 5.13 37.86 5.48 45.87"
      stroke="#000"
      fill="none"
      strokeLinecap="round"
    />
    <text
      y={18.89}
      fontFamily="Virgil, Segoe UI Emoji"
      fontSize={20.812}
      fill="#495057"
      style={{
        whiteSpace: "pre",
      }}
      transform="translate(649.17 23.06)"
      strokeOpacity={0.5}
      fillOpacity={0.5}
    >
      {"Search"}
    </text>
    <path
      d="M618.374 22.012c2.24.13 4.65 2.4 5.65 4.07 1.01 1.66.71 3.68.39 5.91-.32 2.23-1.08 5.84-2.31 7.46-1.23 1.63-3.17 2.23-5.07 2.27-1.9.04-4.6-.81-6.32-2.04-1.72-1.22-3.21-3.6-4.02-5.32-.81-1.72-1.6-3.2-.84-5 .76-1.8 3.34-4.71 5.4-5.8 2.07-1.09 5.64-.9 6.99-.75 1.35.14 1.06 1.28 1.1 1.62m-2.48-.59c1.9.25 5-.03 6.14 1.26 1.13 1.28.86 4.17.68 6.45-.18 2.29-.53 5.35-1.77 7.26-1.24 1.9-4.01 3.95-5.66 4.17-1.65.21-2.57-1.63-4.25-2.89-1.69-1.26-4.96-2.87-5.86-4.66-.9-1.79-.42-4.3.47-6.06.9-1.76 3.05-3.62 4.92-4.49 1.86-.87 5.28-.6 6.29-.74 1-.13-.06.01-.25-.06"
      stroke="#000"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M620.108 39.002c5.13.12 7.74 3.42 10.77 8.34m-9.44-9.23c2.12 2.47 4.54 4.17 10.97 10.16"
      stroke="#000"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
    />
    <text
      y={22}
      fontFamily="Virgil, Segoe UI Emoji"
      fontSize={24.767}
      style={{
        whiteSpace: "pre",
      }}
      transform="translate(333.532 19.18)"
    >
      {"T\xE9my"}
    </text>
  </svg>
)

export default SvgComponent
